import request from '@/utils/request'

export function getCounty(data) {
  return request({
    url: 'api/location/getCounty',
    method: 'post',
    data
  })
}
export function getProvince(data) {
  return request({
    url: 'api/location/getProvince',
    method: 'post',
    data
  })
}
export function getCity(data) {
  return request({
    url: 'api/location/getCity',
    method: 'post',
    data
  })
}
export function sign(data) {
  return request({
    url: 'api/agent/v1/sign',
    method: 'post',
    data
  })
}
export function getRegInfo(data) {
  return request({
    url: 'api/agent/v1/detail',
    method: 'post',
    data
  })
}
